import { BeatLoader } from 'react-spinners';

const LoadingSpinner = ({ size = 12, color = '#3B82F6', text = 'Loading...' }) => {
  return (
    <div className="flex flex-col items-center justify-center py-4">
      <BeatLoader color={color} size={size} margin={5} />
      {text && <p className="mt-3 text-gray-600">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
